module.exports = __webpack_public_path__ + "static/media/2bc69477-90c2-4415-a51f-36e36eee3d5e.8709b494.woff";